export const PersonalCenterRoutes = [{
  path: '/PersonalCenter',
  component: () => import('./PersonalCenter.vue'),
  meta: {
    crumbName: '个人中心'
  },
  children: [
    {
      path: 'personalInfo',
      name: '个人资料编辑',
      component: () => import('../personalInfo.vue'),
      meta: {
        auth:true   //标明是否需要登录后才能访问
      }
    }, {
      path: 'examinerInfo',
      name: '教官资料编辑',
      component: () => import('../examinerInfo.vue'),
      meta: {
        auth:true   //标明是否需要登录后才能访问
      }
    }, {
      path: 'personalDetail',
      name: '个人资料详情',
      component: () => import('../personalDetail.vue'),
      meta: {
        auth:true   //标明是否需要登录后才能访问
      }
    }, {
      path: 'assessmentTask',
      name: '评审任务-正在进行',
      component: () => import('../assessmentTask.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    }, {
      path: 'assessmentTaskHistory',
      name: '评审任务-历史测评',
      component: () => import('../assessmentTaskHistory'),
      meta: {
        auth: true,
      }
    }, {
      path: 'assessmentDetail',
      name: '评审任务-评审详情',
      component: () => import('../assessmentDetail.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    }, {
      path: 'myAssessment',
      name: '我的测评-正在进行',
      component: () => import('../myAssessment.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    }, {
      path: 'myAssessmentHistory',
      name: '我的测评-历史测评',
      component: () => import('../myAssessmentHistory'),
      meta: {
        auth: true,
      }
    }, {
      path: 'myCourse',
      name: '我的课程',
      component: () => import('../myCourse.vue'),
      meta: {
        auth:true,
      }
    }, {
      path: 'certificate',
      name: '我的证书',
      component: () => import('../certificate.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    },{
      path: 'examination',
      name: '我的考试',
      component: () => import('../examination.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    },{
      path: 'PayExamination',
      name: '我的考试',
      component: () => import('../PayExamination.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    },{
      path: 'performance',
      name: '我的成绩',
      component: () => import('../performance.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    }, {
      path: 'myActivity',
      name: '我的活动-正在进行',
      component: () => import('../myActivity.vue'),
      meta: {
        auth:true,  //标明是否需要登录后才能访问
      }
    }, {
      path: 'myActivityHistory',
      name: '我的活动-历史活动',
      component: () => import('../myActivityHistory.vue'),
      meta: {
        auth: true,   //标明是否需要登录后才能访问
      }
    }, {
      path: 'registerInfo',
      name: '测评报名信息',
      component: () => import('../registerInfo.vue'),
      meta: {
        auth:true   //标明是否需要登录后才能访问
      }
    }, {
      path: 'eventInfo',
      name: '活动报名信息',
      component: () => import('../eventInfo.vue'),
      meta: {
        auth:true   //标明是否需要登录后才能访问
      }
    }, {
      path: 'historicalActivityDetail',
      name: '历史活动详情',
      component: () => import('../historicalActivityDetail.vue'),
      meta: {
        auth:true   //标明是否需要登录后才能访问
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/pages/PersonalCenter/router/PersonalCenter.routes.js